import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  gap: 'small' | 'medium';
};

export const Chips = styled.ul<Props>(
  ({gap}) => css`
    display: flex;
    flex-wrap: wrap;
    gap: ${{
      small: '8px',
      medium: '12px',
    }[gap]};
    list-style: none;
    padding: 0;
    margin: 8px 0 0;
  `
);
